import { permissions, profile_types } from "../core/components/common/variables/static_variables";
import RBACScreen from "../core/pages/RBACScreen";
import UserScreen from "../core/pages/UserScreen";
import OrganizationScreen from "../core/pages/OrganizationScreen";
import DriverScreen from "../core/pages/DriverScreen";
import SelectProfile from "../core/pages/SelectProfile";
import { OrganizationCreatePage, OrganizationListPage } from "../plugins/OrganizationPlugin";
import BookingPluginPage from "../plugins/BookingPlugin/pages/booking-plugin.page";
import BookingPage from "../plugins/BookingPlugin/pages/booking.page";
import CreateBookingComponent from "../plugins/BookingPlugin/components/create-booking.component";
import ViewBookingComponent from "../plugins/BookingPlugin/components/view-booking.component";
import DeviceManagementScreen from "../core/pages/DeviceManagementScreen";
import { DeviceManagementListPage } from "../plugins/DeviceManagementPlugin";

import { UserCreatePage, UserListPage } from "../plugins/UserPlugin";
import OrganizationViewPage from "../plugins/OrganizationPlugin/pages/organization-view.page";
import OrganizationUpdatePage from "../plugins/OrganizationPlugin/pages/organization-update.page";
import EditBookingComponent from "../plugins/BookingPlugin/components/edit-booking.component";
import {ContainerPluginPage, ContainerPage, CreateContainerComponent, ViewContainerComponent, EditContainerComponent} from "../plugins/ContainerPlugin";
import GateScreen from "../core/pages/GateScreen";
import { ListGatePage, CreateGatePage, ViewGatePage } from "../plugins/GatePlugin";
import { AccountPage, ProfilePage } from "../plugins/ProfilePlugin";
import {PortPluginPage, PortPage, ViewPortComponent, CreatePortComponent, EditPortComponent} from "../plugins/PortPlugin";
import {GatePassPluginPage, GatePassPage, ViewGatePassPage, GenerateGatepassCreate, EditGatePassComponent} from "../plugins/GatePassPlugin";
import {VehiclePluginPage, VehicleScreen, EditVehicleComponent, ViewVehicleComponent, CreateVehicleComponent} from "../plugins/VehiclePlugin";
import ViewDeviceComponent from "../plugins/DeviceManagementPlugin/components/view-device.component";
import LandingScreen from "../core/pages/LandingScreen";
import UserViewPage from "../plugins/UserPlugin/pages/user-view.page";
import UserUpdatePage from "../plugins/UserPlugin/pages/user-update.page";
import UserProfileViewPage from "../plugins/UserPlugin/pages/user-profile-view.page";
import DashboardPage from "../plugins/DashboardPluging/pages/dashboard-page";
import DashboardScreen from "../core/pages/DashboardScreen";
import LoginScreen from "../core/pages/LoginScreen";
import ViewBusinessDriverComponent from "../plugins/OrganizationPlugin/components/business-driver-component/view-business-driver.component";
import ViewDriverComponent from "../plugins/DriverPlugin/components/view-business-driver.component";
import DriverPage from "../plugins/DriverPlugin/pages/driver.page"
import GatepassCreatePage from "../plugins/GatePassPlugin/pages/generate-gatepass-create.page";
import GatePassConfigurationPage from "../plugins/RoleManagmentPlugin/pages/gatepass-configuration.page";
import {RolesPluginPage, ViewGatePassConfigurationComponent } from "../plugins/RoleManagmentPlugin";
import TestPage from "../core/pages/testpage";
import CreateDriverPage from "../plugins/DriverPlugin/pages/create-driver.page";
import UnauthorizeScreen from "../core/pages/UnauthorizeScreen"


export const routes = [
    {
        path: "/unauthorized",
        element: <UnauthorizeScreen/> ,
        isPrivate: false
    },

    {
        path: "/",
        name: 'LandingScreen', 
        element: <LandingScreen />,
        isPrivate: false
    },

    {
        path: "/login",
        name: "LoginScreen", 
        element: <LoginScreen />,
        isGuestOnly: true,
        isPrivate: false
    },
    
    {
        path: "/rbac",
        name: 'RBACScreen', 
        element: <RBACScreen />,
        isPrivate: true,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE],
    },

    {
        path: "/rbac/gatepass-configuration",
        name: "RolesPluginPage", 
        element: <RolesPluginPage />,
        isPrivate: true,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE],
        children: [
            {
                path: "",
                element: <GatePassConfigurationPage />,
            },
            {
                path: "view",
                element: <ViewGatePassConfigurationComponent />,
            },
        ]
    },

    {
        path: "/user",
        name: 'UserScreen', 
        element: <UserScreen/>,
        isPrivate: true,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin', 'Employee', 'PortDriver', 'Staff'] },
            { profileType: profile_types.BUSINESS, roles: ['Owner', 'Employee', 'BusinessOwner', 'BusinessDriver', 'BusinessEmployee'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE, profile_types.BUSINESS],
        children: [
            {
                index: true,
                element: <UserListPage />,
                requiredPermission: permissions.users.LIST_ACCOUNT ,
                isPrivate: true,
            },
            {
                path: "create",
                element: <UserCreatePage />,
                requiredPermission: permissions.users.CREATE_ACCOUNT,
                isPrivate: true,
            },
            {
                path: "view",
                element: <UserViewPage />,
                requiredPermission: permissions.users.VIEW_USER_PROFILE,
                isPrivate: true,
            },
            {
                path: "update",
                element: <UserUpdatePage />,
                requiredPermission: permissions.users.UPDATE_ACCOUNT,
                isPrivate: true,
            },
            {
                path: "view/profile",
                element: <UserProfileViewPage />,
                requiredPermission: permissions.users.VIEW_USER_PROFILE,
                isPrivate: true,
            },
        ]
    },

    {
        path: "/profile",
        name: 'ProfileScreen', 
        element: <ProfilePage />,
        isPrivate: true,
    },

    {
        path: "/account",
        name: 'AccountScreen', 
        element: <AccountPage />,
        isPrivate: true,
    },

    {
        path: "/organization",
        name: 'OrganizationScreen', 
        element: <OrganizationScreen/>,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin', 'Employee', 'Staff'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE],
        isPrivate: true,
        children: [
            {
                index: true,
                element: <OrganizationListPage />,
                isPrivate: true,
                requiredPermission: permissions.organizations.LIST_ORGANIZATION,
            },
            {
                path: "create",
                element: <OrganizationCreatePage />,
                isPrivate: true,
                requiredPermission: permissions.organizations.CREATE_ORGANIZATION,
            },
            {
                path: "view",
                element: <OrganizationViewPage />,
                isPrivate: true,
                requiredPermission: permissions.organizations.VIEW_ORGANIZATION,
            },
            {
                path: "view/vehicles",
                element: <OrganizationViewPage />,
                isPrivate: true,
                requiredPermission: permissions.organizations.VIEW_ORGANIZATION,
            },
            {
                path: "view/gatepass",
                element: <OrganizationViewPage />,
                isPrivate: true,
                requiredPermission: permissions.organizations.VIEW_ORGANIZATION,
            },
            {
                path: "view/bookings",
                element: <OrganizationViewPage />,
                isPrivate: true,
                requiredPermission: permissions.organizations.VIEW_ORGANIZATION,
            },
            {
                path: "view/containers",
                element: <OrganizationViewPage />,
                isPrivate: true,
                requiredPermission: permissions.organizations.VIEW_ORGANIZATION,
            },
            {
                path: "view/users",
                element: <OrganizationViewPage />,
                isPrivate: true,
                requiredPermission: permissions.organizations.VIEW_ORGANIZATION,
            },
            {
                path: "view/drivers",
                element: <OrganizationViewPage />,
                isPrivate: true,
                requiredPermission: permissions.organizations.VIEW_ORGANIZATION,
            },
            {
                path: "update",
                element: <OrganizationUpdatePage />,
                isPrivate: true,
                requiredPermission: permissions.organizations.UPDATE_ORGANIZATION,
            },
            {
                path: "driver/view",
                element: <ViewBusinessDriverComponent />,
                requiredPermission: permissions.drivers.VIEW_DRIVER,
                isPrivate: true,
            },

            {
                path: "driver/create",
                element: <CreateDriverPage />,
                isPrivate: true,
                requiredPermission: permissions.drivers.CREATE_DRIVER,
            },

            {
                path: "view/bookings/create",
                element: <CreateBookingComponent />,
                requiredPermission: permissions.booking.CREATE_BOOKING,
            },
            {
                path: "view/bookings/view",
                element: <ViewBookingComponent />,
                requiredPermission: permissions.booking.VIEW_BOOKING,
            },
            {
                path: "view/bookings/edit",
                element: <EditBookingComponent />,
                requiredPermission: permissions.booking.UPDATE_BOOKING,
            },

            {
                path: "view/vehicles/create",
                element: <CreateVehicleComponent />,
                requiredPermission: permissions.vehicle.CREATE_VEHICLE,
            },
            {
                path: "view/vehicles/view",
                element: <ViewVehicleComponent />,
                requiredPermission: permissions.vehicle.VIEW_VEHICLE,
            },
            {
                path: "view/vehicles/edit",
                element: <EditVehicleComponent />,
                requiredPermission: permissions.vehicle.UPDATE_VEHICLE,
            },

            {
                path: "view/containers/create",
                element: <CreateContainerComponent />,
                requiredPermission: permissions.containers.CREATE_CONTAINER,
            },
            {
                path: "view/containers/view",
                element: <ViewContainerComponent />,
                requiredPermission: permissions.containers.VIEW_CONTAINER,
            },
            {
                path: "view/containers/edit",
                element: <EditContainerComponent />,
                requiredPermission: permissions.containers.CHANGE_UPDATE_CONTAINER,
            },
            {
                path: "view/drivers",
                element: <ViewBusinessDriverComponent />,
                // requiredPermission: permissions.containers.VIEW_ORGANIZATION_DRIVER,
            },
            {
                path: "view/gatepass/create",
                element: <GatepassCreatePage />,
            },

            {
                path: "user/create",
                element: <UserCreatePage />,
                requiredPermission: permissions.users.CREATE_ACCOUNT,
                isPrivate: true,
            },
        ]
    },
    {

        path: "/driver",
        name: "DriverScreen", 
        element: <DriverScreen />,
        isPrivate: true,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin', 'Employee', 'PortDriver', 'Staff'] },
            { profileType: profile_types.BUSINESS, roles: ['Owner', 'Employee', 'BusinessOwner', 'BusinessDriver', 'BusinessEmployee'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE, profile_types.BUSINESS],
        children: [
            {
                index: true,
                element: <DriverPage/>,
                isPrivate: true,
                requiredPermission: permissions.drivers.LIST_DRIVER,
            },
            {
                path: "create",
                element: <CreateDriverPage />,
                isPrivate: true,
                requiredPermission: permissions.drivers.CREATE_DRIVER,
            },
            {
                path: "view",
                element: <ViewDriverComponent />,
                isPrivate: true,
                requiredPermission: permissions.drivers.VIEW_DRIVER,
            },
        ]
    },

    {
        path: "/gate-pass",
        name: "GatePassScreen", 
        isPrivate: true,
    },

    {
        path: "/gatepass/create",
        name: "GenerateGatepassCreate", 
        element: <GenerateGatepassCreate />,
        isPrivate: true
    },

    {
        path:"/view-org",
        isPrivate:true
    },

    {
        path: "/select-profile",
        name: "SelectProfile", 
        element: <SelectProfile />,
        isPrivate: true
    },

    {
        path: "/bookings",
        element: <BookingPluginPage />,
        isPrivate: true,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin', 'Employee', 'PortDriver', 'Staff'] },
            { profileType: profile_types.BUSINESS, roles: ['Owner', 'Employee', 'BusinessOwner', 'BusinessDriver', 'BusinessEmployee'] },
            { profileType: profile_types.INDIVIDUAL, roles: ['Driver', 'Resident'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE, profile_types.BUSINESS, profile_types.INDIVIDUAL],
        children: [
            {
                path: "",
                element: <BookingPage />,
                requiredPermission: permissions.booking.LIST_BOOKING,
            },
            {
                path: "create",
                element: <CreateBookingComponent />,
                requiredPermission: permissions.booking.CREATE_BOOKING,
            },
            {
                path: "view",
                element: <ViewBookingComponent />,
                requiredPermission: permissions.booking.VIEW_BOOKING,
            },
            {
                path: "edit",
                element: <EditBookingComponent />,
                requiredPermission: permissions.booking.UPDATE_BOOKING,
            },
        ],
    },

    {
        path: "/containers",
        element: <ContainerPluginPage />,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin', 'Employee', 'PortDriver', 'Staff'] },
            { profileType: profile_types.BUSINESS, roles: ['Owner', 'Employee', 'BusinessOwner', 'BusinessDriver', 'BusinessEmployee'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE, profile_types.BUSINESS],
        isPrivate: true,
        children: [
            {
                path: "",
                element: <ContainerPage />,
                requiredPermission: permissions.containers.LIST_CONTAINER,
            }, 
            {
                path: "create",
                element: <CreateContainerComponent />,
                requiredPermission: permissions.containers.CREATE_CONTAINER,
            },
            {
                path: "view",
                element: <ViewContainerComponent />,
                requiredPermission: permissions.containers.VIEW_CONTAINER,
            },
            {
                path: "edit",
                element: <EditContainerComponent />,
                requiredPermission: permissions.containers.CHANGE_UPDATE_CONTAINER,
            },
        ],
    },

    {
        path: "/device-management",
        element: <DeviceManagementScreen />,
        isPrivate: true,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin', 'Employee', 'PortDriver', 'Staff'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE],
        children: [
            {
                index: true,
                element: <DeviceManagementListPage />,
                requiredPermission: permissions.deviceManagement.LIST_DEVICE,
                isPrivate: true,
            },
            {
                path: "view",
                element: <ViewDeviceComponent />,
                isPrivate: true,
            },
            {
                path: "register",
                
            }
        ]
    },

    {
        path: "/ports",
        element: <PortPluginPage />,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin', 'Employee', 'PortDriver', 'Staff'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE],
        isPrivate: true,
        children: [
            {
                path: "",
                element: <PortPage />,
                requiredPermission: permissions.ports.LIST_PORT,
            },
            {
                path: "view",
                element: <ViewPortComponent />,
                requiredPermission: permissions.ports.VIEW_PORT,
            },
            {
                path: "create",
                element: <CreatePortComponent />,
                requiredPermission: permissions.ports.CREATE_PORT,
            },
            {
                path: "edit",
                element: <EditPortComponent />,
                requiredPermission: permissions.ports.CHANGE_UPDATE_PORT,
            },
        ]
    },

    {
        path: "/gates",
        element: <GateScreen />,
        isPrivate: true,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin', 'Employee', 'PortDriver', 'Staff'] },
            { profileType: profile_types.BUSINESS, roles: ['Owner', 'Employee', 'BusinessOwner', 'BusinessDriver', 'BusinessEmployee'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE, profile_types.BUSINESS],
        children: [
            {
                index: true,
                element: <ListGatePage />,
                requiredPermission: permissions.gate.LIST_GATE,
            },
            {
                path: "create",
                element: <CreateGatePage />,
                requiredPermission: permissions.gate.CREATE_GATE,
            },
            {
                path: "view",
                element: <ViewGatePage />,
                requiredPermission: permissions.gate.VIEW_GATE,
            },
        ],
    },
   {
        path: "/gatepass",
        element: <GatePassPluginPage />,
        isPrivate: true,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin', 'Employee', 'PortDriver', 'Staff'] },
            { profileType: profile_types.BUSINESS, roles: ['BusinessOwner', 'BusinessDriver', 'BusinessEmployee'] },
            { profileType: profile_types.INDIVIDUAL, roles: ['Driver', 'Resident'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE, profile_types.BUSINESS, profile_types.INDIVIDUAL],
        children: [
            {
                path: "",
                element: <GatePassPage />,
                requiredPermission: permissions.gatepass.LIST_GATEPASS,
            },
            {
                path: "view",
                element: <ViewGatePassPage />,
                requiredPermission: permissions.gatepass.VIEW_GATEPASS,
            },
            {
                path: "create",
                element: <GenerateGatepassCreate />,
                requiredPermission: permissions.gatepass.GENERATE_VEHICLE_GATEPASS,
            },
            {
                path: "edit",
                element: <EditGatePassComponent />,
                requiredPermission: permissions.gatepass.UPDATE_GATEPASS,
            },
        ]
    },

    {
        path: "/vehicles",
        element: <VehiclePluginPage />,
        isPrivate: true,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin', 'Employee','PortDriver', 'Staff'] },
            { profileType: profile_types.BUSINESS, roles: ['Owner', 'Employee', 'BusinessOwner', 'BusinessDriver', 'BusinessEmployee'] },
            { profileType: profile_types.INDIVIDUAL, roles: ['Driver', 'Resident'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE, profile_types.BUSINESS, profile_types.INDIVIDUAL],
        roles: [],
        children: [
            {
                path: "",
                element: <VehicleScreen />,
                requiredPermission: permissions.vehicle.LIST_VEHICLE,
            },
            {
                path: "edit",
                element: <EditVehicleComponent />,
                requiredPermission: permissions.vehicle.UPDATE_VEHICLE,
            },
            {
                path: "view",
                element: <ViewVehicleComponent />,
                requiredPermission: permissions.vehicle.VIEW_VEHICLE,
            },
            {
                path: "create",
                element: <CreateVehicleComponent />,
                requiredPermission: permissions.vehicle.CREATE_VEHICLE,
            }
        ]
    },
    {
        path: "/dashboard",
        element: <DashboardScreen />,
        isPrivate: true,
        allowedProfileTypes: [
            { profileType: profile_types.PORT_EMPLOYEE, roles: ['Admin', 'Employee', 'GateAttendant', 'PortDriver', 'Staff'] },
            { profileType: profile_types.BUSINESS, roles: ['Owner', 'Employee', 'BusinessOwner', 'BusinessDriver', 'BusinessEmployee'] },
            { profileType: profile_types.INDIVIDUAL, roles: ['Driver', 'Resident'] },
        ],
        // allowedProfileTypes: [profile_types.PORT_EMPLOYEE, profile_types.BUSINESS, profile_types.INDIVIDUAL],
        children: [
            {
                path: "",
                element: <DashboardPage />,
            },
           
        ]
    },

    {
        path:'/test-page',
        element: <TestPage />,
        isPrivate: true,
    }

]
